<script setup>
import TenantFaqTable from "@frontJs/components/tables/projectManagement/tenantReports/TenantFaqTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import {
  ServerStackIcon,
  StarIcon,
  ShoppingBagIcon,
  HandThumbUpIcon,
  ChatBubbleLeftRightIcon,
  ArrowPathIcon,
  BugAntIcon,
  LightBulbIcon,
  ChartBarSquareIcon,
  BookOpenIcon,
  LinkIcon,
  TruckIcon,
} from "@heroicons/vue/24/solid";
import { Head } from "@inertiajs/vue3";
import GoogleAdsIcon from "@js/components/icons/colored/GoogleAdsIcon.vue";
import GoogleMyBusinessIcon from "@js/components/icons/colored/GoogleMyBusinessIcon.vue";
import ListGroup from "@js/components/lists/ListGroup.vue";
import ListItem from "@js/components/lists/ListItem.vue";
import TabGroup from "@js/components/tabs/TabGroup.vue";
import TabPanel from "@js/components/tabs/TabPanel.vue";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const selectedTab = ref(0);

function changeTab(index) {
  selectedTab.value = index;
}

const documentDefinitions = ref({
  storeAndEcommerce: [
    {
      title: "Boutique et E-commerce - BX Logistique Réclamations",
      link: "https://drive.google.com/file/d/1Ze6W0fEWqjRmj2o1ecUI3KUyl4jFH0Uu/view ",
      icon: TruckIcon,
    },
  ],
  datakepler: [
    {
      title: "Datakepler - Avis vérifiés",
      link: "https://docs.google.com/document/d/1t6WPt49QTKNHbGMZho9rT-gwnedrkeR4NvHQF-SXsaA/edit",
      icon: StarIcon,
    },
    {
      title: "Datakepler - Google My Business",
      link: "https://docs.google.com/document/d/1UBStwidUqWg9gMLD4bfuHC7whPoZggfmqWk2Kp-w62o/edit",
      icon: GoogleMyBusinessIcon,
    },
    {
      title: "Datakepler - Google Ads",
      link: "https://docs.google.com/document/d/1zIjG1l_JmFEGpFEsf2ioaN5FGMKCZ6RXbyhYTfHiTBY/edit",
      icon: GoogleAdsIcon,
    },
    {
      title: "Datakepler - Relance panier",
      link: "https://docs.google.com/document/d/1WYPw49PogeYX2Zmiu4e3CSki8j7aTsyc43g2IsKCP1M/edit",
      icon: ShoppingBagIcon,
    },
  ],
  dev: [
    {
      title: "DEV - Bonne pratiques",
      link: "https://docs.google.com/document/d/1rtNE3q6yRuM8nfJapml2avIIpuj8aJsTqajccltdozs/edit",
      icon: HandThumbUpIcon,
    },
    {
      title: "DEV - BUGS",
      link: "https://docs.google.com/document/d/1DTMzhRpXA_vgkzTMaUNLPrCRl3bHOggL0-UPV6HLBN0/edit",
      icon: BugAntIcon,
    },
    {
      title: "DEV - FAQ",
      link: "https://docs.google.com/document/d/1rtNE3q6yRuM8nfJapml2avIIpuj8aJsTqajccltdozs/edit",
      icon: ChatBubbleLeftRightIcon,
    },
    {
      title: "DEV - MAJ W11",
      link: "https://docs.google.com/document/d/1xsMLwtVVpVXTZwwAa7Zw7QNkE7GLThS9HWEot27F2bU/edit",
      icon: ArrowPathIcon,
    },
    {
      title: "DEV - Migration OpenMage",
      link: "https://docs.google.com/document/d/1nKmdy3K1Or0NhCTprijMFyap--J9QA-RwP6w9bhBrpQ/edit",
      icon: ArrowPathIcon,
    },
    {
      title: "DEV - Performances",
      link: "https://docs.google.com/document/d/16sAvTTLZ1ZVzriPGfJGxs3yikXUPYFYL-5TuouY4ijY/edit",
      icon: ChartBarSquareIcon,
    },
    {
      title: "DEV - Proxy debug",
      link: "https://docs.google.com/document/d/1UkRMYgE7EAV7C3gZcRZSmeGLbqiLfxyCMW9hOYMp9BU/edit",
      icon: BugAntIcon,
    },
    {
      title: "DEV - Serveurs / Mails / Tel Apikom",
      link: "https://docs.google.com/document/d/1v9XF18WLXoDfvx6d_nMGdFHn0ZhborqcryZWA8Wpzl8/edit",
      icon: ServerStackIcon,
    },
    {
      title: "DEV - Stratégie",
      link: "https://docs.google.com/document/d/1mRql155uMAMqGhXsF0ocoeJVyKZFUnRl4K5GmwPSqbE/edit",
      icon: LightBulbIcon,
    },
  ],
  geo: [
    {
      title: "GEO - Bonnes pratiques",
      link: "https://docs.google.com/document/d/168Cq6IERSesyuO1mtGv2IjYlnf-J_7_VMY5j8ihF7x8/edit",
      icon: HandThumbUpIcon,
    },
  ],
  sea: [
    {
      title: "SEA - Bonnes pratiques",
      link: "https://docs.google.com/document/d/1_odQuAIvE_N6aBCCxCE60t8KzH-ALVhswsSBGdES3pQ/edit",
      icon: HandThumbUpIcon,
    },
  ],
  seo: [
    {
      title: "SEO - Annuaires",
      link: "https://docs.google.com/spreadsheets/d/1Te0mX-hfPTW5ihV28GWEkuI6_ykkJ-fqXXCbAqeMOrw/edit",
      icon: BookOpenIcon,
    },
    {
      title: "SEO - Bonnes pratiques",
      link: "https://docs.google.com/document/d/1llAqCkJABjJv3DV8qQGAVTdxsBIHY8K3C9y2DAeADTk/edit",
      icon: HandThumbUpIcon,
    },
    {
      title: "SEO - Netlinking Linkuma / Apikom",
      link: "https://docs.google.com/spreadsheets/d/1ZVmqprEIcZs4UMkVQBxjQLnh-IeF6j7IIw3_CU4XRpI/edit",
      icon: LinkIcon,
    },
  ],
  smo: [
    {
      title: "SMO - Bonnes pratiques",
      link: "https://docs.google.com/document/d/1Nzqa4tSGgFI8RZ5uUTinTADuzpV_jm-oZAYeueVURUQ/edit",
      icon: HandThumbUpIcon,
    },
  ],
  sma: [
    {
      title: "SMA - Bonnes pratiques",
      link: "https://docs.google.com/document/d/1_DGalufG_XqoGBNsbNklnIaAGYCc8wmf-BhAsvOQosE/edit",
      icon: HandThumbUpIcon,
    },
  ],
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title>
      {{ t("title.docAndFaq") }} - {{ t("title.projectManagement") }} -
      {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle>
    {{ t("title.projectManagement") }} - {{ t("title.docAndFaq") }}
  </PageTitle>

  <TabGroup
    :selected-tab="selectedTab"
    :change-tab="changeTab"
    :tabs="{
      all: t('title.all'),
      storeAndEcommerce: t('title.storeAndEcommerce'),
      datakepler: t('title.datakepler'),
      dev: t('title.dev'),
      geo: t('title.geo'),
      sea: t('title.sea'),
      seo: t('title.seo'),
      sma: t('title.sma'),
      smo: t('title.smo'),
      faq: t('title.faq'),
    }"
  >
    <template #panels>
      <TabPanel without-background unmount>
        <ListGroup
          v-for="(
            documentDefinition, documentDefinitionIndex
          ) in documentDefinitions"
          :key="documentDefinitionIndex"
          class="mb-4"
        >
          <ListItem
            v-for="(document, documentIndex) in documentDefinition"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.storeAndEcommerce"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.datakepler"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.dev"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.geo"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.sea"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.seo"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.sma"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <ListGroup>
          <ListItem
            v-for="(document, documentIndex) in documentDefinitions.smo"
            :key="documentIndex"
            :icon="document.icon"
            :link="document.link"
          >
            {{ document.title }}
          </ListItem>
        </ListGroup>
      </TabPanel>

      <TabPanel without-background unmount>
        <TenantFaqTable />
      </TabPanel>
    </template>
  </TabGroup>
</template>
